@if (content.cards) {
  <div>
    <div class="skymiles-landing-page-offers">
      @for (card of content.cards; track $index) {
        <idp-card
          [contents]="card"
          (notify)="clickAnalyticsEvent.emit(card)"
        ></idp-card>
      }
    </div>
  </div>
}
